import {
  UserCredential,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from "firebase/auth";

import { getFirebaseAuth } from "~/lib/client/firebase";
import { createGraphqlClient } from "~/lib/graphql/graphqlClient";

/**
 * firebase と fussy db にユーザを作成する
 * @param name
 * @param email
 * @param password
 */
export const signupWithFirebaseAuth = async (
  name: string,
  email: string,
  password: string
) => {
  const auth = getFirebaseAuth();
  const credential = await createUserWithEmailAndPassword(
    auth,
    email,
    password
  );
  const idToken = await credential.user.getIdToken();
  const graphqlClient = await createGraphqlClient();
  return await graphqlClient.createUserWithIdToken({
    firebaseIdToken: idToken,
    name: name,
    bio: null,
  });
};

export const loginWithFirebaseAuth = async (
  email: string,
  password: string
): Promise<UserCredential> => {
  const auth = getFirebaseAuth();
  return await signInWithEmailAndPassword(auth, email, password);
};

export const logoutWithFirebaseAuth = async () => {
  await getFirebaseAuth().signOut();
};
